// src/app/router/index.tsx
import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import { AuthRoutes, ProtectedRoutes } from '@/features/auth';
import { ErrorPage } from '@/pages/other/ErrorPage';
import { AccessDenied } from '@/pages/other/AccessDenied';
import { Home as Dashboard } from '@/pages/dashboard';
import { AccountSecurity } from '@/pages/account/AccountSecurity';
// Feature route imports
import { loginRoute, mfaRoutes, logoutRoute, forgotPasswordRoute, resetPasswordRoute } from '@/features/auth/router';
import { customersRoutes } from '@/features/customers';
import { vehiclesRoutes } from '@/features/vehiclesearch';
import { dealersRoutes } from '@/features/dealers';
import { quoteRoutes } from '@/features/quote';
import { dashboardRoutes } from '@/features/dashboard';
import { agreementsRoutes } from '@/features/agreements';
import { smrAdminRoutes } from '@/features/smr-admin/router';
import { usersRoutes } from '@/features/users';
import { securityAdminRoutes } from '@/features/security-admin';
import { rolesRoutes } from '@/features/roles';
import { documentTemplatesRoutes } from '@/features/document-templates';
import { motHistoryRoutes } from '@/features/mot-history/router';

export const appRoutes: RouteObject[] = [
    // Public Auth routes
    {
        path: '/',
        element: <AuthRoutes />,
        errorElement: <ErrorPage />,
        children: [
            // Public routes
            ...loginRoute,
            ...mfaRoutes,
            ...forgotPasswordRoute,
            ...resetPasswordRoute,
        ],
    },
    ...logoutRoute,
    // Protected routes
    {
        path: '/',
        element: <ProtectedRoutes />,
        errorElement: <ErrorPage />,
        children: [
            { index: true, element: <Dashboard /> },
            ...customersRoutes,
            ...vehiclesRoutes,
            ...motHistoryRoutes,
            ...dealersRoutes,
            ...quoteRoutes,
            ...dashboardRoutes,
            ...agreementsRoutes,
            ...smrAdminRoutes,
            ...usersRoutes,
            ...securityAdminRoutes,
            ...rolesRoutes,
            ...documentTemplatesRoutes,
            {
                path: 'account/security',
                element: <AccountSecurity />,
            },
            {
                path: 'access-denied',
                element: <AccessDenied />,
            },
        ],
    },
    // Catch all
    {
        path: '*',
        element: <div>404 - Page Not Found</div>,
    },
];

export const router = createBrowserRouter(appRoutes);
